module.exports = __webpack_public_path__ + "static/media/visa.24e27b56.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/services/meet_and_greet/visa.jpg
// module id = 168
// module chunks = 0 2